import {FC, useCallback, useEffect, useMemo} from 'react';
import {useField} from 'formik';
import DatePicker from '@mui/lab/DatePicker';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import {
  dateFormatDDMMYYYY
} from '../../../../constants/constants';
import {calculateMinDate} from '../../date_time_picker/helpers';
import DateProvider from '../../date_time_picker/Provider';
import {DateTimePickerFieldProps} from './DateTimePickerField';

const DatePickerField: FC<DateTimePickerFieldProps> = ({
  name,
  label,
  disabled = false,
  onChange: onChangeCallback,
  required = false,
  validationType,
  placeholder,
  now,
  type
}) => {
  const [
    {value},
    {touched},
    {setTouched, setValue}
  ] = useField(name);

  const minDate = useMemo(() => {
    return calculateMinDate(type, validationType);
  }, [type, validationType]);

  const handleChange = useCallback((newValue) => {
    if (onChangeCallback) {
      return onChangeCallback(value);
    }

    setValue(newValue);
    setTouched(true);
  }, [onChangeCallback]);

  useEffect(() => {
    if (!touched && !!now) {
      setTouched(true);
      setValue(dayjs());
    }
  }, []);

  return (
    <DateProvider>
      <DatePicker
        value={value}
        renderInput={(props) =>
          <TextField
            {...props}
            placeholder={placeholder}
            size="small"
            required={required}
            className="date-picker"
          />
        }
        onChange={handleChange}
        minDate={minDate}
        disabled={disabled}
        label={label}
        clearable={!disabled}
        desktopModeMediaQuery="@media (pointer: fine)"
        inputFormat={dateFormatDDMMYYYY}
      />
    </DateProvider>
  );
};

export default DatePickerField;
